import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { Button, ScrollView } from "devextreme-react";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";
import axios from "../../api-axios";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { criarEntregadorDs } from "../../DataSources";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";

const data = new Date();
const template = {
  id: undefined,
  prefeituraId: undefined,
  codBarras: undefined,
  ano: data.getFullYear(),
  numero: undefined,
  status: 0,
  dataEnvio: data,
  dataEntrega: data,
  recebedor: undefined,
  tipoDeDocumento: undefined,
  nomeDocumento: undefined,
  documento: undefined,
  entregadorId: undefined,
  orgaoEmissor: undefined,
  testemunha1: undefined,
  testemunha2: undefined,
  popupEntregadorVisivel: false,
};

export default class ProtocoloEntregaNotificacao extends React.Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.state = { ...template, prefeituraId: UserInfo.getPrefeitura() };
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.excluirBaixa = this.excluirBaixa.bind(this);
    this.entregadorDs = criarEntregadorDs();

    this.tiposDataSource = [
      { id: "I", descricao: "Interno" },
      { id: "E", descricao: "Externo" },
    ];

    this.statusOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "1 - GERADA" },
        { id: 1, descricao: "2 - ENVIADA" },
        { id: 2, descricao: "3 - ENTREGUE" },
        { id: 3, descricao: "4 - NÃO ENCONTRADO" },
        { id: 4, descricao: "5 - RECUSADO" },
        { id: 5, descricao: "6 - CANCELADO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoDocumentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "CNPJ" },
        { id: 2, descricao: "CPF" },
        { id: 3, descricao: "RG" },
        { id: 4, descricao: "OUTRO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    /*
    // Syscode Entregador
    */
    this.setEntregadorId = this.setEntregadorId.bind(this);
    this.pesquisarEntregador = this.pesquisarEntregador.bind(this);
    this.onEntregadorSelecionadoPesquisa = this.onEntregadorSelecionadoPesquisa.bind(
      this
    );
    this.entregadorBoxRef = React.createRef();
    this.renderEntregador = sysCodigoDescricao(
      () => this.state.entregadorId,
      this.setEntregadorId,
      () => this.state._uiNomeEntregador,
      this.pesquisarEntregador
    );
    this.atualizarNomeEntregador = this.atualizarNomeEntregador.bind(this);
    /*
    // Syscode Entregador End
    */
  }

  /*
  // Syscode Entregador Functions
  */

  setEntregadorId(data) {
    this.setState({ entregadorId: data.value });
    this.atualizarNomeEntregador();
  }

  atualizarNomeEntregador() {
    this.entregadorDs
      .load({
        filter: [["sequencial", "=", this.state.entregadorId]],
      })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setState({
            _uiNomeEntregador: result[0].nome,
          });
        } else {
          this.setState({ _uiNomeEntregador: "" });
        }
      })
      .catch((_) => this.setState({ _uiNomeEntregador: "<<ERRO>>" }));
  }

  onEntregadorSelecionadoPesquisa(e) {
    this.setState({
      entregadorId: e.row.data.sequencial,
      popupEntregadorVisivel: false,
    });
    this.atualizarNomeEntregador();
  }

  pesquisarEntregador() {
    this.setState({ popupEntregadorVisivel: true });
  }
  /*
  // Syscode Entregador Functions End
  */

  componentDidMount() {
    if (this.props.location.data !== undefined) {
      this.setState({
        ...template,
        codBarras: this.props.location.data.codigoDeBarras,
        ano: this.props.location.data.ano,
        numero: this.props.location.data.numero,
      });
    } else {
      this.setState({
        ...template,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2} labelLocation={"top"}>
              <GroupItem
                caption="PROTOCOLO DE ENTREGA"
                colSpan={2}
                colCount={6}
              >
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField="codBarras">
                  <Label text="Código de Barras" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={1} dataField="ano">
                  <Label text="Ano" />
                </SimpleItem>
                <SimpleItem colSpan={3} dataField="numero">
                  <Label text="Número" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem
                  colSpan={4}
                  dataField="status"
                  editorType={"dxSelectBox"}
                  editorOptions={this.statusOptions}
                >
                  <Label text="Status" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem
                  colSpan={2}
                  dataField="dataEnvio"
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehaviour: true }}
                >
                  <Label text="Envio em" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField="dataEntrega"
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehaviour: true }}
                >
                  <Label text="Entregue em" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"recebedor"}>
                  <Label text="Recebedor" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem
                  colSpan={4}
                  dataField="tipoDeDocumento"
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoDocumentoOptions}
                >
                  <Label text="Tipo de Documento" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"nomeDocumento"}>
                  <Label text="Nome do Documento" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"documento"}>
                  <Label text="Documento" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"orgaoEmissor"}>
                  <Label text="Órgão Emissor" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} component={this.renderEntregador}>
                  <Label text="Código do Entregador" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"testemunha1"}>
                  <Label text="Testemunha 1" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <EmptyItem colSpan={1} />
                <SimpleItem colSpan={4} dataField={"testemunha2"}>
                  <Label text="Testemunha 2" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button width={120} text="Cancelar" onClick={this.cancel} />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  type={"danger"}
                  text="Excluir"
                  onClick={this.excluirBaixa}
                />
              </div>
            </div>
          </form>
        </div>
        <Popup
          visible={this.state.popupEntregadorVisivel}
          onHiding={() => this.setState({ popupEntregadorVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Entregador"
        >
          <ScrollView showScrollbar="onScroll">
            <div className={"content-block dx-card responsive-paddings"}>
              <h3>ENTREGADORES</h3>
              <br />
              <br />
              <DataGrid
                dataSource={criarEntregadorDs()}
                showBorders={true}
                rowAlternationEnabled={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                columnAutoWidth={true}
                focusedRowEnabled={true}
              >
                <Column
                  type="buttons"
                  fixed={true}
                  fixedPosition={"left"}
                  buttons={[
                    {
                      hint: "Selecionar",
                      icon: "repeat",
                      onClick: (e) => this.onEntregadorSelecionadoPesquisa(e),
                    },
                  ]}
                />
                <Column
                  dataField={"sequencial"}
                  caption={"#"}
                  alignment={"center"}
                  width={80}
                />
                <Column dataField={"tipo"} caption={"Tipo"}>
                  <Lookup
                    dataSource={this.tiposDataSource}
                    valueExpr={"id"}
                    displayExpr={"descricao"}
                  />
                </Column>
                <Column dataField={"nome"} caption={"Nome"} />
                <Column dataField={"cpf"} caption={"CPF"} />
                <Column dataField={"matricula"} caption={"Matrícula"} />
                <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                />
              </DataGrid>
            </div>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupEntregadorVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    if (this.state.dataEntrega >= this.state.dataEnvio) {
      axios
        .post(`notificacaodiat/protocolo/${UserInfo.getPrefeitura()}`, {
          ...this.state,
        })
        .then((response) => {
          if (response.status === 200) {
            notify("Notificação realizada com sucesso", "success");
            this.props.history.goBack();
          }
        })
        .catch((error) => {
          console.log(error);
          var resp = error.response;
          if (resp != undefined) {
            console.log(resp);
            if (resp.status === 400) {
              ShowError(resp.data);
            }
          } else {
            ShowError(error);
          }
        });
    }
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }

  excluirBaixa() {
    // if (this.state.damSequencial == undefined) {
    //     ShowError("Informe o código do DAM a ser excluído   ");
    // }
    // axios.post("dam/excluir_baixa_manual", this.state)
    //     .then(_ => {
    //         notify("Baixa excluída com sucesso", "success");
    //         const form = this.formRef.current.instance;
    //         const novoEstado = { ...template, prefeituraId: UserInfo.getPrefeitura() };
    //         form.updateData(novoEstado);
    //         form.getEditor("tipoBaixa").focus();
    //         console.log(this.state);
    //     })
    //     .catch(error => {
    //         console.log(error.response);
    //         if (error.response && error.response.data && error.response.data.erros) {
    //             ShowError(error.response.data.erros);
    //         }
    //         else {
    //             ShowError(error.response.data);
    //         }
    //     });
  }
}
